import { cn } from '@/lib/utils'

const COLORS = ['#8B5CF6', '#06B6D4', '#F59E0B', '#EC4899', '#10B981', '#3B82F6', '#EF4444']

function colorFor(id: string) {
  let hash = 0
  for (const char of id) hash = (hash * 31 + char.charCodeAt(0)) | 0
  return COLORS[Math.abs(hash) % COLORS.length]
}

interface MemberAvatarProps {
  userId: string
  name: string
  avatarUrl?: string | null
  size?: 'xs' | 'sm' | 'md'
  className?: string
}

/** Member photo, or initials on a color derived from the user id */
export function MemberAvatar({
  userId,
  name,
  avatarUrl,
  size = 'md',
  className,
}: MemberAvatarProps) {
  const sizes = { xs: 'h-5 w-5 text-[10px]', sm: 'h-7 w-7 text-xs', md: 'h-9 w-9 text-sm' }
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('')

  return avatarUrl ? (
    <img
      src={avatarUrl}
      alt={name}
      title={name}
      referrerPolicy="no-referrer"
      className={cn('shrink-0 rounded-full object-cover', sizes[size], className)}
    />
  ) : (
    <span
      title={name}
      role="img"
      aria-label={name}
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full font-semibold text-white',
        sizes[size],
        className
      )}
      style={{ backgroundColor: colorFor(userId) }}
    >
      {initials || '?'}
    </span>
  )
}
